// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1Gnmj","error":"Textarea_error__aU4yF","readonly":"Textarea_readonly__AVFPm","disabled":"Textarea_disabled__3afk_"};